import { colorsByFunction, marketingColors } from "UI/colors";

import { addOpacity, lightenDarkenColor } from "Utilities/Colors/colorUtils";

const collapsedNavWidth = 40;
const fullScreenBreakpoint = 840;
const closeButtonMargin = 12;
const fullScreenMargin = 4;
const fullScreenBorderRadius = 26;
const outerPaddingExpanded = 8;
const outerPaddingCompressed = 4;
const toolbarButtonSize = 44;
const toolbarPadding = 8;
const supersearchWidth = 240;
const groupSearchWidth = 296;
const springAnimation = {
  type: "spring",
  damping: 15,
  mass: 0.7,
  stiffness: 120,
};
const fullScreenListItemWidth = 306;
const listItemWidth = 314;
const closedNavSectionHeightSm = 36;
const closedNavSectionHeightLg = 56;
const navSectionGap = 16;
const listIconProps = { size: "sm", color: "textLight", yCorrection: -1 };
const menuIconProps = { size: "md", color: "textLight" };
const nonOpaqueTextWhite = addOpacity(colorsByFunction.textLight, 0.8);
const navigationGradientColors = [
  lightenDarkenColor(marketingColors.darkBlue, 35),
  marketingColors.darkBlue,
];
const collapseButtonSize = 48;
const everyoneButtonHeight = 30;
const smallViewportHeightBreakpoint = 700;
const inactiveNavSectionPaddingTop = 2;
const inactiveNavSectionMarginBottom = -6;
const activeSectionMarginTop = 6.5;
const activeSectionMarginBottom = 7.5;
const accountAndSettingsBottomPadding = 20;
const navBarPrimaryContentSpacingY = 0;

export {
  listIconProps,
  collapsedNavWidth,
  fullScreenBreakpoint,
  closeButtonMargin,
  springAnimation,
  fullScreenMargin,
  fullScreenBorderRadius,
  outerPaddingExpanded,
  outerPaddingCompressed,
  toolbarButtonSize,
  toolbarPadding,
  supersearchWidth,
  closedNavSectionHeightSm,
  closedNavSectionHeightLg,
  navSectionGap,
  nonOpaqueTextWhite,
  menuIconProps,
  navigationGradientColors,
  groupSearchWidth,
  fullScreenListItemWidth,
  listItemWidth,
  collapseButtonSize,
  everyoneButtonHeight,
  smallViewportHeightBreakpoint,
  inactiveNavSectionPaddingTop,
  inactiveNavSectionMarginBottom,
  activeSectionMarginTop,
  activeSectionMarginBottom,
  accountAndSettingsBottomPadding,
  navBarPrimaryContentSpacingY,
};
